import React, { useEffect, useState } from "react";
import logoWhite from "@/assets/SVG/logo_white.svg";
import { NavLink } from "react-router-dom";
// import legal1 from "@/assets/PNG/Gibraltar-financial-services-commission-transparent 1.png";
// import legal2 from "@/assets/PNG/HM government gibraltar2 1.png";
// import legal3 from "@/assets/PNG/svg4596.png";
// import legal4 from "@/assets/PNG/6amld2 2.png";

const Footer: React.FC = () => {
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  const checkIsMobile = () => {
    setIsMobile(window.innerWidth <= 899);
  };

  useEffect(() => {
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => {
      window.removeEventListener("resize", checkIsMobile);
    };
  }, []);
  return (
    <div className="footer">
      <div className="footer__top px-[13rem] max-[1440px]:px-[5rem]">
        <div className="footer__top__title">
          Your Next Destination
          <br /> For Crypto Conversions
          <br /> And Fintech Services
        </div>
        <div className="footer__top__text">
          Exchanging cryptocurrencies for fiat currencies made easy with
          Leonext, the advanced service provider that takes your business into
          the future. 
        </div>
        <NavLink to="/contact" className="footer__top__button">
          Contact Us
        </NavLink>
        <div className="footer__top__arrows">
          {isMobile ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="122"
              height="122"
              viewBox="0 0 122 122"
              fill="none"
            >
              <path
                d="M0 38.8682H83.1899V122L122 83.2028V0H38.9165L0 38.8682Z"
                fill="#12213B"
              />
            </svg>
          ) : (
            <svg
              width="723"
              height="734"
              viewBox="0 0 723 734"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 267.917H466.409V734L684 516.481V50H218.188L0 267.917Z"
                fill="#111B31"
                fill-opacity="0.02"
              />
              <path
                d="M208 164.075H559.17V515L723 351.225V0H372.279L208 164.075Z"
                fill="#12213B"
              />
            </svg>
          )}
        </div>
      </div>
      {isMobile ? (
        <div className="footer__bot">
          <div className=" flex justify-between items-center mb-[2rem] mt-[2rem] px-[1rem]">
            <img className="w-[139px]" src={logoWhite}></img>
            <div className=" flex justify-center items-center  gap-4 z-[2]">
              <a
                href="https://www.facebook.com/profile.php?id=61571469413978"
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="23"
                  viewBox="0 0 13 23"
                  fill="none"
                  className="cursor-pointer"
                >
                  <path
                    d="M12.2011 9.92093L11.9309 12.1689C11.8851 12.5444 11.5781 12.8268 11.2139 12.8268H7.69875V22.2254C7.32804 22.2601 6.95243 22.2779 6.57274 22.2779C5.72354 22.2779 4.89476 22.1899 4.09374 22.0224V12.8268H1.39018C1.14195 12.8268 0.939453 12.6163 0.939453 12.3583V9.54543C0.939453 9.28748 1.14195 9.0769 1.39018 9.0769H4.09374V4.85841C4.09374 2.26964 6.1114 0.171387 8.60102 0.171387H11.7553C12.0035 0.171387 12.206 0.381973 12.206 0.63992V3.45281C12.206 3.71076 12.0035 3.92134 11.7553 3.92134H9.50166C8.5063 3.92134 7.69956 4.7603 7.69956 5.79632V9.07774H11.485C11.9194 9.07774 12.255 9.47354 12.2019 9.92178L12.2011 9.92093Z"
                    fill="white"
                  />
                </svg>
              </a>

              <a
                href="https://www.instagram.com/leonext.exchange?igsh=ZHl3Ym56ZmZyeGl1"
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  className="cursor-pointer"
                >
                  <path
                    d="M13.1201 0.171387H4.31698C2.04864 0.171387 0.208984 2.07681 0.208984 4.42624V13.544C0.208984 15.8935 2.04864 17.7989 4.31698 17.7989H13.1201C15.3884 17.7989 17.2281 15.8935 17.2281 13.544V4.42624C17.2281 2.07681 15.3884 0.171387 13.1201 0.171387ZM15.7607 13.2396C15.7607 14.9175 14.4461 16.2791 12.8261 16.2791H4.61012C2.99011 16.2791 1.67548 14.9175 1.67548 13.2396V4.72985C1.67548 3.05193 2.99011 1.69031 4.61012 1.69031H12.8261C14.4461 1.69031 15.7607 3.05193 15.7607 4.72985V13.2396Z"
                    fill="white"
                  />
                  <path
                    d="M8.72731 4.42627C6.29811 4.42627 4.32617 6.4687 4.32617 8.98474C4.32617 11.5008 6.29811 13.5432 8.72731 13.5432C11.1565 13.5432 13.1284 11.5008 13.1284 8.98474C13.1284 6.4687 11.1565 4.42627 8.72731 4.42627ZM8.72731 12.0234C7.11056 12.0234 5.79267 10.6584 5.79267 8.98389C5.79267 7.30935 7.11056 5.94436 8.72731 5.94436C10.344 5.94436 11.6619 7.30935 11.6619 8.98389C11.6619 10.6584 10.344 12.0234 8.72731 12.0234Z"
                    fill="white"
                  />
                  <path
                    d="M13.4212 5.0336C12.9362 5.0336 12.541 4.62426 12.541 4.1219C12.541 3.61954 12.9362 3.21021 13.4212 3.21021C13.9063 3.21021 14.3015 3.61954 14.3015 4.1219C14.3015 4.62426 13.9063 5.0336 13.4212 5.0336Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/leonextexchange/"
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  className="cursor-pointer"
                >
                  <path
                    d="M2.31608 4.49982C3.47009 4.49982 4.4056 3.53087 4.4056 2.33561C4.4056 1.14035 3.47009 0.171387 2.31608 0.171387C1.16207 0.171387 0.226562 1.14035 0.226562 2.33561C0.226562 3.53087 1.16207 4.49982 2.31608 4.49982Z"
                    fill="white"
                  />
                  <path
                    d="M3.90079 5.94263H0.730177C0.644044 5.94263 0.574219 6.01495 0.574219 6.10416V16.6013C0.574219 16.6905 0.644044 16.7629 0.730177 16.7629H3.90079C3.98692 16.7629 4.05675 16.6905 4.05675 16.6013V6.10416C4.05675 6.01495 3.98692 5.94263 3.90079 5.94263Z"
                    fill="white"
                  />
                  <path
                    d="M15.896 9.90997V16.0415C15.896 16.4381 15.5824 16.7629 15.1995 16.7629H13.11C12.727 16.7629 12.4135 16.4381 12.4135 16.0415V10.9917C12.4135 9.99624 11.6337 9.18856 10.6726 9.18856C9.71154 9.18856 8.93175 9.99624 8.93175 10.9917V16.0415C8.93175 16.4381 8.6182 16.7629 8.23524 16.7629H6.14572C5.76277 16.7629 5.44922 16.4381 5.44922 16.0415V6.66322C5.44922 6.26658 5.76277 5.94182 6.14572 5.94182H8.23524C8.6182 5.94182 8.93175 6.26658 8.93175 6.66322V7.125C9.62826 6.19047 10.7812 5.58154 12.0656 5.58154C13.9877 5.58154 15.896 7.02435 15.896 9.90997Z"
                    fill="white"
                  />
                </svg>
              </a>
            </div>
          </div>
          <div className="px-[1rem] flex flex-col gap-4 pb-4">
            <div className="footer__bot__text">
              “Leonext” is a brand and business name owned by Leotus Limited.
              Leotus Limited is a company incorporated and registered in
              Gibraltar under the registration number 122758, with registered
              address at: Finsbury House, 32 Line Wall Road, Gibraltar GX11 1AA,
              holding tax identification number (TIN) 714727. Leotus Limited is
              authorised and regulated by the Gibraltar Financial Services
              Commission (GFSC) as a Virtual Asset Arrangement Provider.
            </div>
            <div className="footer__bot__text">
              <span className="font-bold">
                Disclaimer
                <br />
              </span>
              Purchasing and investing in Digital Assets is a high-risk activity
              which incurs risks which are not inherent in managing traditional
              financial instruments and other assets. The value of digital
              assets, other digital assets or fiat currencies is not indicative
              of future performance.
            </div>
          </div>
          <div className="footer__pages__copyRight pb-4">
            {/* <div className="flex flex-col gap-12 items-center py-[2rem]">
              <img src={legal1} />
              <img src={legal2} />
              <div className="flex gap-8">
                <img src={legal3} />
                <img src={legal4} />
              </div>
            </div> */}
            <div className="flex gap-5 flex-wrap justify-center">
              <NavLink
                to={"/wpp"}
                onClick={handleClick}
                className="cursor-pointer"
              >
                Privacy and Cookies
              </NavLink>

              <NavLink
                to={"/tou"}
                onClick={handleClick}
                className="cursor-pointer"
              >
                Terms & Conditions
              </NavLink>
            </div>
          </div>
        </div>
      ) : (
        <div className="footer__bot px-[13rem] max-[1440px]:px-[5rem] max-[899px]:px-[1rem]">
          <div className="w-full flex py-[2rem] items-start justify-between max-[899px]:flex-col">
            <div className="w-[33rem] flex flex-col">
              <div className="h-[6rem] flex justify-start items-center mb-[2rem]">
                <img className="w-[14.4rem]" src={logoWhite}></img>
              </div>
              <div className="footer__bot__text w-[23rem]">
                “Leonext” is a brand and business name owned by Leotus Limited.
                Leotus Limited is a company incorporated and registered in
                Gibraltar under the registration number 122758, with registered
                address at: Finsbury House, 32 Line Wall Road, Gibraltar GX11
                1AA, holding tax identification number (TIN) 714727. Leotus
                Limited is authorised and regulated by the Gibraltar Financial
                Services Commission (GFSC) as a Virtual Asset Arrangement
                Provider.
              </div>
            </div>
            <div className="w-full flex flex-col ps-[2rem]">
              <div className="text-[#fff] flex gap-12 w-full h-[6rem] justify-start items-center mb-[2rem]">
                <NavLink
                  to="/"
                  onClick={handleClick}
                  className={({ isActive }) =>
                    isActive
                      ? "footer__pages__link !font-bold"
                      : "footer__pages__link"
                  }
                >
                  Home
                </NavLink>
                <NavLink
                  to="/solutions"
                  onClick={handleClick}
                  className={({ isActive }) =>
                    isActive
                      ? "footer__pages__link !font-bold"
                      : "footer__pages__link"
                  }
                >
                  Solutions
                </NavLink>
                <NavLink
                  to="/about"
                  onClick={handleClick}
                  className={({ isActive }) =>
                    isActive
                      ? "footer__pages__link !font-bold"
                      : "footer__pages__link"
                  }
                >
                  About Us
                </NavLink>
                <NavLink
                  to="/faq"
                  onClick={handleClick}
                  className={({ isActive }) =>
                    isActive
                      ? "footer__pages__link !font-bold"
                      : "footer__pages__link"
                  }
                >
                  FAQ's
                </NavLink>
                {/* <NavLink
                  to="/blog"
                  onClick={handleClick}
                  className={({ isActive }) =>
                    isActive
                      ? "footer__pages__link !font-bold"
                      : "footer__pages__link"
                  }
                >
                  Insights
                </NavLink> */}
                <NavLink
                  to="/contact"
                  onClick={handleClick}
                  className={({ isActive }) =>
                    isActive
                      ? "footer__pages__link !font-bold"
                      : "footer__pages__link"
                  }
                >
                  Contact
                </NavLink>
              </div>
              <div className="footer__bot__text w-[23rem]">
                <span className="font-bold">Disclaimer</span>
                <br />
                Purchasing and investing in Digital Assets is a high-risk
                activity which incurs risks which are not inherent in managing
                traditional financial instruments and other assets. The value of
                digital assets, other digital assets or fiat currencies is not
                indicative of future performance.
              </div>
            </div>

            <div className="h-[6rem] flex justify-start items-center mb-[2rem] gap-4 z-[2]">
              <a
                href="https://www.facebook.com/profile.php?id=61571469413978"
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="23"
                  viewBox="0 0 13 23"
                  fill="none"
                  className="cursor-pointer"
                >
                  <path
                    d="M12.2011 9.92093L11.9309 12.1689C11.8851 12.5444 11.5781 12.8268 11.2139 12.8268H7.69875V22.2254C7.32804 22.2601 6.95243 22.2779 6.57274 22.2779C5.72354 22.2779 4.89476 22.1899 4.09374 22.0224V12.8268H1.39018C1.14195 12.8268 0.939453 12.6163 0.939453 12.3583V9.54543C0.939453 9.28748 1.14195 9.0769 1.39018 9.0769H4.09374V4.85841C4.09374 2.26964 6.1114 0.171387 8.60102 0.171387H11.7553C12.0035 0.171387 12.206 0.381973 12.206 0.63992V3.45281C12.206 3.71076 12.0035 3.92134 11.7553 3.92134H9.50166C8.5063 3.92134 7.69956 4.7603 7.69956 5.79632V9.07774H11.485C11.9194 9.07774 12.255 9.47354 12.2019 9.92178L12.2011 9.92093Z"
                    fill="white"
                  />
                </svg>
              </a>

              <a
                href="https://www.instagram.com/leonext.exchange?igsh=ZHl3Ym56ZmZyeGl1"
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  className="cursor-pointer"
                >
                  <path
                    d="M13.1201 0.171387H4.31698C2.04864 0.171387 0.208984 2.07681 0.208984 4.42624V13.544C0.208984 15.8935 2.04864 17.7989 4.31698 17.7989H13.1201C15.3884 17.7989 17.2281 15.8935 17.2281 13.544V4.42624C17.2281 2.07681 15.3884 0.171387 13.1201 0.171387ZM15.7607 13.2396C15.7607 14.9175 14.4461 16.2791 12.8261 16.2791H4.61012C2.99011 16.2791 1.67548 14.9175 1.67548 13.2396V4.72985C1.67548 3.05193 2.99011 1.69031 4.61012 1.69031H12.8261C14.4461 1.69031 15.7607 3.05193 15.7607 4.72985V13.2396Z"
                    fill="white"
                  />
                  <path
                    d="M8.72731 4.42627C6.29811 4.42627 4.32617 6.4687 4.32617 8.98474C4.32617 11.5008 6.29811 13.5432 8.72731 13.5432C11.1565 13.5432 13.1284 11.5008 13.1284 8.98474C13.1284 6.4687 11.1565 4.42627 8.72731 4.42627ZM8.72731 12.0234C7.11056 12.0234 5.79267 10.6584 5.79267 8.98389C5.79267 7.30935 7.11056 5.94436 8.72731 5.94436C10.344 5.94436 11.6619 7.30935 11.6619 8.98389C11.6619 10.6584 10.344 12.0234 8.72731 12.0234Z"
                    fill="white"
                  />
                  <path
                    d="M13.4212 5.0336C12.9362 5.0336 12.541 4.62426 12.541 4.1219C12.541 3.61954 12.9362 3.21021 13.4212 3.21021C13.9063 3.21021 14.3015 3.61954 14.3015 4.1219C14.3015 4.62426 13.9063 5.0336 13.4212 5.0336Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/leonextexchange/"
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  className="cursor-pointer"
                >
                  <path
                    d="M2.31608 4.49982C3.47009 4.49982 4.4056 3.53087 4.4056 2.33561C4.4056 1.14035 3.47009 0.171387 2.31608 0.171387C1.16207 0.171387 0.226562 1.14035 0.226562 2.33561C0.226562 3.53087 1.16207 4.49982 2.31608 4.49982Z"
                    fill="white"
                  />
                  <path
                    d="M3.90079 5.94263H0.730177C0.644044 5.94263 0.574219 6.01495 0.574219 6.10416V16.6013C0.574219 16.6905 0.644044 16.7629 0.730177 16.7629H3.90079C3.98692 16.7629 4.05675 16.6905 4.05675 16.6013V6.10416C4.05675 6.01495 3.98692 5.94263 3.90079 5.94263Z"
                    fill="white"
                  />
                  <path
                    d="M15.896 9.90997V16.0415C15.896 16.4381 15.5824 16.7629 15.1995 16.7629H13.11C12.727 16.7629 12.4135 16.4381 12.4135 16.0415V10.9917C12.4135 9.99624 11.6337 9.18856 10.6726 9.18856C9.71154 9.18856 8.93175 9.99624 8.93175 10.9917V16.0415C8.93175 16.4381 8.6182 16.7629 8.23524 16.7629H6.14572C5.76277 16.7629 5.44922 16.4381 5.44922 16.0415V6.66322C5.44922 6.26658 5.76277 5.94182 6.14572 5.94182H8.23524C8.6182 5.94182 8.93175 6.26658 8.93175 6.66322V7.125C9.62826 6.19047 10.7812 5.58154 12.0656 5.58154C13.9877 5.58154 15.896 7.02435 15.896 9.90997Z"
                    fill="white"
                  />
                </svg>
              </a>
            </div>
          </div>
          <div className="footer__pages__copyRight">
            <div className="flex gap-12 items-center py-[2rem]">
              {/* <img src={legal1} />
              <img src={legal2} />
              <img src={legal3} />
              <img src={legal4} /> */}
            </div>
            <div className="flex gap-8">
              <NavLink
                to={"/wpp"}
                onClick={handleClick}
                className="cursor-pointer"
              >
                Privacy and Cookies
              </NavLink>
              <NavLink
                to={"/tou"}
                onClick={handleClick}
                className="cursor-pointer"
              >
                Terms & Conditions
              </NavLink>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Footer;
